<template>
  <section class="requests section">
    <div class="container" :class="{ 'inside-iframe': auth.iframeSrc }">
      <div
        class="d-flex justify-content-center mb-2 mt-3"
        v-if="auth.iframeSrc"
      >
        <button @click="goToMap()" class="btn btn-outline-primary mr-3">
          <i class="fas fa-map-marked-alt"></i> Vendors Map
        </button>
        <button @click="doLogout()" class="btn btn-outline-danger">
          <i class="fas fa-sign-out-alt"></i> Logout
        </button>
      </div>
      <ul class="nav nav-tabs mb-4 requests-nav">
        <li class="nav-item">
          <router-link
            to="/orders"
            data-v-step="sentReferrals"
            class="nav-link px-3"
            active-class="active"
          >
            Sent Referrals
            <badge
              type="pill"
              color="primary"
              v-if="orders.requests.pagination.total > 0"
              >{{ orders.requests.pagination.total }}</badge
            >
          </router-link>
        </li>
        <li class="nav-item" v-if="user.isVendor || user.isAdmin">
          <router-link
            to="/received-referrals"
            data-v-step="receivedReferrals"
            class="nav-link px-3"
            active-class="active"
          >
            Received Referrals
            <badge
              type="pill"
              color="primary"
              v-if="orders.newReceivedCount > 0"
              >{{ orders.newReceivedCount }}</badge
            >
          </router-link>
        </li>
      </ul>
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Auth from "../../auth";

export default {
  name: "orders",
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    ...mapState(["orders", "loading", "auth"]),
    user: function () {
      return Auth.user.get();
    },
  },
  methods: {
    ...mapActions({
      doLogout: "auth/logout",
    }),
    goToMap: function () {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style lang="css">
@import "../../../node_modules/flatpickr/dist/flatpickr.min.css";
</style>
<style scoped lang="scss">
.inside-iframe {
  max-width: 100%;
}

.requests {
  @media (min-width: 1200px) {
    .container {
      max-width: 90%;
    }
  }

  @media (min-width: 1600px) {
    .container {
      max-width: 1500px;
    }
  }
}
@media (max-width: 767px) {
  .requests-nav {
    justify-content: space-between;
  }
}
</style>
